import userManager from "../userManager";

const startLogout = 'START_LOGOUT';

export const initialState = { 'isLoggingOut': false };

export const actionCreators = {
  startLogout: () => async (dispatch, getState) => {
    dispatch({type: startLogout});
    userManager.signoutRedirect({'id_token_hint': getState().oidc.user.id_token});
    userManager.removeUser();
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === startLogout) {
    console.log("user is logging out");
    return {
      ...state,
      isLoggingOut: true
    };
  }

  return state;
};